export default {
  zh: {
    topLovers:"Top Lovers",
    rule: 'Rules',
  },
  ar: {
    topLovers:"اقوى العشاق",
    treeOfLovers:"شجرة الحب",
    rule: 'القواعد',
    timeR: 'العد التنازلي',
    days: 'أيام',
    ranking:"التصنيف",
    rewards:"جوائز",
    rulesDeil:`1. خلال شهر رمضان، سيتم تسجيل الهدايا التي يرسلها المستخدمون على البرودكاست وإحصاءها في هذه القائمة.<br/><br/>

    2. سيتم احتساب جميع الهدايا التي يرسلها المستخدمين خلال فترة الحدث.<br/><br/>
    
    3. بعد الحدث، سيحصل أفضل 10 مستخدمين على مكافآت.`,
    get: "يستلم",
    monthly: 'المكافأت الشهرية',
    dailyBenefits: 'المكافأت اليومية',
    trFive:"الجائزة",
    ruby:"روبي",
    gold: "ذهب",
    register:`١. المكافآت الشهرية: عندما يصل شحن المشترك إلى المبلغ المحدد، يجب على المشترك النقر يدويًا على زر "استلام" لتلقي هدية الحزمة بأكملها
    <br/>٢. يتم إعادة تعيين المكافآت في اليوم الأول من كل شهر. ستفقد المكافآت اذا لم يتم استلامها قبل نهاية الموعد المحدد.ولن تكون الادارة مسؤوله عن الهدايا المفقودة
    <br/> ٣. للمستخدمين الذين حصلوا على معرف خاص بهم. يرجى الاتصال بفريق الادارة. سوف تحتاج  الهدايا الخاصة إلى 7 أيام لإنتاجها
    <br/> ٤. سيتم احتساب نشاط إعادة الشحن حسب توقيت المملكة العربية السعودية اعتباراً من اليوم الأول من كل شهر وحتى اليوم الأول من الشهر التالي
    <br/> ٥. اذا حصلت على نجم الشحن لثلاث مرات متتالية، سوف تحصل عليه بشكل دائم
    <br/> ٦. للإدارة كامل الصلاحيات لتعديل او ترقية هذا النشاط وقواعده
    <br/> ٧. التوقيت الشهري هو توقيت السعودية من الأول من كل شهر إلى الأول من الشهر التالي
    <br/> ٨.  لمزيد من التفاصيل تواصل ب آيدي رقم 1`,
    goldRule: `
    1. المكافأة اليومية: عندما يقوم المشاركون بإعادة شحن مبلغ محدد ، يجب على المشاركين النقر يدويًا إلى زر "Get" للحصول على عملات  إضافية
    <br/>2.المكافآت الشهرية: عندما يصل المشاركون إلى هذا المبلغ المحدد ، يجب على المشاركين النقر يدويًا إلى زر "GET" لتلقي هدية حزمة بأكملها
    <br/>3. أفعال لا يطالب بها أحد ، سيفقد المشاركون جوائزهم إذا فشلوا في استرداد جوائزهم. لن تكون App مسؤولة عن أي هدايا مفقودة
    <br/>4. للمستخدمين الذين تلقوا الايدي الخاص. يرجى الاتصال بفريق App. ستحتاج منتجات الايدي الخاصة إلى 7 أيام لإنتاجها
    <br/>5. سيستند نشاط  الشحن إلى وقت المملكة العربية السعودية من الأول من كل شهر إلى الأول من الشهر المقبل
    <br/>6. بعد الحصول على Recharge Stars  لمدة 3 وقت متتالي ، سيكون لديك بشكل دائم
    <br/>7. لها الحق النهائي في هذا النشاط App
    <br/>
    <br/>- قواعد ترقية  الايدي إعادة الشحن الشهرية 
    <br/>1. الوقت الشهري هو الوقت السعودي من الأول من كل شهر إلى الأول من الشهر المقبل
    <br/>2. لا يمكن تحويل الايدي إلى حسابات أخرى
    <br/>3. يمكن تعيين كل الايدي مرة واحدة في الشهر من خلال إعادة الشحن الشهرية 
    <br/>4. يمكن لكل حساب الحصول على الايدي واحد فقط من خلال إعادة الشحن الشهري لكل حساب 
    <br/>5. ارجو تتواصل الايدي: 1 لمعرفه التفاصيل 
    `,
    r: "الشحن",
    help:'مساعدة الشحن',
  },
  en: {
    topLovers:"Top Lovers",
    treeOfLovers:"Tree of Lovers",
    rule: 'Rules',
    timeR: 'Count down: ',
    days: 'days',
    ranking:"Ranking",
    rewards:"Rewards",
    rulesDeil:`1.During Ramadan , gifts sent by users on broadcast will be recorded and tallied in this list.<br/><br/>
    2.Gifts sent by users with multiple messages will be combined and counted.<br/><br/>
    3.After the event, the top 10 users will receive rewards.`,
    get: "Get",
    monthly: 'Monthly Benefits',
    dailyBenefits: 'Daily Benefits',
    trFive:"Reward",
    ruby:"Ruby",
    gold: "Gold",
    register:`1. Monthly rewards: When participant‘s recharge reaches that specific amount, participant must manually click the "receive" button to receive the entire package gift<br/>
    2. Rewards reset on the 1st of every month.Unclaimed actions, Participants will lose their prizes if they fail to redeem their prizes. App will not be responsible for any missing gifts.<br/>
    3. For users who received their Special ID. Please contact the App team. Special Gifts productions will need 7 days to produce.<br/>
    4. Recharge activity will be based on KSA time from the 1st of every month to the 1st of the next month.<br/>
    5. After obtaining the Recharge Stars for 3 consecutive time. you will have it permanently<br/>
    6. App has the final right of this activity Monthly recharge ID upgrade rules<br/>
    7. The monthly time is Saudi time from the 1st of each month to the 1st of next month.<br/>
    8. For more details contact ID 1.`,
    goldRule: `
    1. Daily rewards: When  participants recharge reach a specific amount, participants must manually click the "Get" button in order to receive the extra coins.<br/>
    2. Monthly rewards: When participants recharge reaches that specific amount, participants must manually click the "GET" button to receive the entire package gift.<br/>
    3. Unclaimed actions, Participants will lose their prizes if they fail to redeem their prizes. App will not be responsible for any missing gifts.<br/>
    4. For users who received their Special ID. Please contact the App team. Special Gifts productions will need 7 days to produce.<br/>
    5. Recharge activity will be based on KSA time from the 1st of every month to the 1st of the next month.<br/>
    6. After obtaining the Recharge Stars for 3 consecutive time, you will have it permanently.<br/>
    7. App has the final right of this activity . <br/><br/>
    - Monthly recharge ID upgrade rules <br/>
    1. The monthly time is Saudi time from the 1st of each month to the 1st of next month. <br/>
    2. ID can not be transfer to other accounts. <br/>
    3. Every ID can set one time a month through the monthly recharge. <br/>
    4. Each account can only get one ID per monthl through monthly recharge. <br/>
    5. To more details contact ID 1. <br/>
    `,
    r: "Recharge",
    help:'Help',
  },
  tr: {
    topLovers:"En İyi Aşıklar",
    treeOfLovers:"Sevgi̇ler Ağaci",
    rule: 'Kural',
    timeR: 'Kalan süre: ',
    days: 'gün',
    ranking:"Sıralama",
    rewards:"Ödüller",
    rulesDeil:`1.Ramazan ayı boyunca yayında kullanıcıların gönderdiği hediyeler bu listeye kaydedilecek ve sayılacaktır.<br/><br/>
    2.Kullanıcıların birden fazla mesajla gönderdiği hediyeler birleştirilecek ve sayılacaktır.<br/><br/>
    3.Etkinlik sonrasında ilk 10 kullanıcıya ödüller verilecektir.`,
    get: "AI",
    monthly: 'Aylık Bonuslar',
    dailyBenefits: 'Günlük Bonuslar',
    trFive:"Ödül",
    ruby:"Yakut",
    gold: "Altın",
    register:`1. Aylık Ödüller: Katılımcının çekimi belirli bir miktara ulaştığında, paket hediyesinin tamamını almak için katılımcının manuel olarak "Al" düğmesine tıklaması gerekir.<br/>
    2. Ödüller her ayın 1'inde sıfırlanır. Talep edilmeyen işlemlerde, katılımcılar ödüllerini kullanamazlarsa ödüllerini kaybedeceklerdir. App eksik veya alınmamış hediyelerden sorumlu olmayacaktır<br/>
    3. Özel ID alan kullanıcılar için. Lütfen App ekibiyle iletişime geçin. Özel Hediye yapımların üretimi 7 güne ihtiyaç duyacaktır.<br/>
    4. Yeniden yükleme etkinliği her ayın 1'inden bir sonraki ayın 1'ine kadar TR zamanına göre yapılacaktır.<br/>
    5. Art arda 3 kez Şarj Yıldızını aldıktan sonra ona kalıcı olarak sahip olacaksın<br/>
    6.Bu aktivitenin son hakkı App'ye aittir. <br/>
    Aylık yeniden yükleme kimliği yükseltme kuralları<br/>
    7. Aylık zaman, her ayın 1'inden sonraki ayın 1'ine kadar TR zamanıdır.<br/>
    8. Daha fazla ayrıntı için ID: SELMAN ile iletişime geçin.`,
    goldRule: `
    1. Günlük ödüller: Katılımcıların şarjı belirli bir miktara ulaştığında, ekstra jetonları almak için katılımcıların manuel olarak "Al" düğmesini tıklamaları gerekir.<br/>
    2. Aylık ödüller: Katılımcıların şarjı belirli bir miktara ulaştığında, katılımcıların tüm paket hediyesini almak için manuel olarak "AL" düğmesini tıklamaları gerekir.<br/>
    3. Talep edilmeyen eylemler, Katılımcılar ödüllerini kullanamazlarsa ödüllerini kaybedeceklerdir. App, eksik hediyelerden sorumlu olmayacaktır.<br/>
    4. Özel Kimliklerini alan kullanıcılar için. Lütfen App ekibiyle iletişime geçin. Özel Hediyeler yapımlarının üretilmesi 7 güne ihtiyaç duyacaktır.<br/>
    5. Yeniden doldurma etkinliği, her ayın 1'inden sonraki ayın 1'ine kadar TR zamanına dayalı olacaktır.<br/>
    6. Ardışık 3 kez Yeniden Doldurma Yıldızları elde ettikten sonra, ona kalıcı olarak sahip olacaksınız.<br/>
    7. Bu aktivitenin son hakkı App'ye aittir. <br/><br/>
    - Aylık şarj kimliği yükseltme kuralları <br/>
    1. Aylık saat, her ayın 1'inden sonraki ayın 1'ine kadar TR saatidir. <br/>
    2. Kimlik başka hesaplara aktarılamaz. <br/>
    3. Her kimlik, aylık şarj yoluyla ayda bir kez ayarlanabilir. <br/>
    4. Her hesap, aylık şarj ile ayda yalnızca bir kimlik alabilir. <br/>
    5. Daha fazla ayrıntı için ID SELMAN  ile iletişime geçin. <br/>
    `,
    r: "Çekim Yap",
    help:'Yardım',
  },
  fa:{
    "topLovers": "عاشقان برتر",
    "treeOfLovers": "درخت عاشقان",
    "rule": "قوانین",
    "timeR": "شمارش معکوس: ",
    "days": "روزها",
    "ranking": "رتبه‌بندی",
    "rewards": "جوایز",
    "rulesDeil":
      "۱. در طول ماه رمضان، هدایای ارسال‌شده توسط کاربران در پخش زنده ثبت شده و در این لیست شمارش می‌شوند.<br/><br/>" +
      "۲. هدایای ارسال‌شده توسط کاربران با چندین پیام ترکیب شده و محاسبه خواهند شد.<br/><br/>" +
      "۳. پس از پایان رویداد، ۱۰ کاربر برتر جوایزی دریافت خواهند کرد.",
    "get": "دریافت",
    "monthly": "مزایای ماهانه",
    "dailyBenefits": "مزایای روزانه",
    "trFive": "جایزه",
    "ruby": "یاقوت",
    "gold": "طلا",
    "register":
      "۱. جوایز ماهانه: زمانی که میزان شارژ شرکت‌کننده به مقدار مشخصی برسد، باید دکمه \"دریافت\" را به‌صورت دستی کلیک کند تا بسته جایزه کامل را دریافت کند.<br/>" +
      "۲. جوایز در اول هر ماه بازنشانی می‌شوند. در صورت عدم دریافت، شرکت‌کنندگان جوایز خود را از دست خواهند داد و برنامه هیچ مسئولیتی در قبال هدایای از دست‌رفته ندارد.<br/>" +
      "۳. کاربرانی که شناسه ویژه دریافت کرده‌اند، لطفاً با تیم برنامه تماس بگیرند. تولید هدایای ویژه ۷ روز زمان می‌برد.<br/>" +
      "۴. فعالیت شارژ بر اساس زمان عربستان از اول هر ماه تا اول ماه بعد خواهد بود.<br/>" +
      "۵. پس از دریافت ستاره‌های شارژ به مدت ۳ بار متوالی، آن را به‌طور دائمی خواهید داشت.<br/>" +
      "۶. برنامه حق نهایی در مورد این فعالیت را دارد.<br/>" +
      "۷. زمان ماهانه مطابق با ساعت عربستان از اول هر ماه تا اول ماه بعد است.<br/>" +
      "۸. برای اطلاعات بیشتر با شناسه ۱ تماس بگیرید.",
    "goldRule":
      "۱. جوایز روزانه: زمانی که میزان شارژ شرکت‌کننده به مقدار مشخصی برسد، باید دکمه \"دریافت\" را به‌صورت دستی کلیک کند تا سکه‌های اضافی را دریافت کند.<br/>" +
      "۲. جوایز ماهانه: زمانی که میزان شارژ شرکت‌کننده به مقدار مشخصی برسد، باید دکمه \"دریافت\" را به‌صورت دستی کلیک کند تا بسته جایزه کامل را دریافت کند.<br/>" +
      "۳. در صورت عدم دریافت، شرکت‌کنندگان جوایز خود را از دست خواهند داد و برنامه هیچ مسئولیتی در قبال هدایای از دست‌رفته ندارد.<br/>" +
      "۴. کاربرانی که شناسه ویژه دریافت کرده‌اند، لطفاً با تیم برنامه تماس بگیرند. تولید هدایای ویژه ۷ روز زمان می‌برد.<br/>" +
      "۵. فعالیت شارژ بر اساس زمان عربستان از اول هر ماه تا اول ماه بعد خواهد بود.<br/>" +
      "۶. پس از دریافت ستاره‌های شارژ به مدت ۳ بار متوالی، آن را به‌طور دائمی خواهید داشت.<br/>" +
      "۷. برنامه حق نهایی در مورد این فعالیت را دارد.<br/><br/>" +
      "- قوانین ارتقاء شناسه شارژ ماهانه <br/>" +
      "۱. زمان ماهانه مطابق با ساعت عربستان از اول هر ماه تا اول ماه بعد است.<br/>" +
      "۲. شناسه قابل انتقال به سایر حساب‌ها نیست.<br/>" +
      "۳. هر شناسه فقط یک بار در ماه می‌تواند از طریق شارژ ماهانه تنظیم شود.<br/>" +
      "۴. هر حساب تنها می‌تواند یک شناسه در هر ماه از طریق شارژ ماهانه دریافت کند.<br/>" +
      "۵. برای اطلاعات بیشتر با شناسه ۱ تماس بگیرید.",
    "r": "شارژ",
    "help": "کمک"
},
    pt:{
    "topLovers": "Top Lovers",
    "treeOfLovers": "Árvore dos Amantes",
    "rule": "Regras",
    "timeR": "Contagem regressiva: ",
    "days": "dias",
    "ranking": "Classificação",
    "rewards": "Recompensas",
    "rulesDeil":
      "1. Durante o Ramadã, os presentes enviados pelos usuários na transmissão serão registrados e contados nesta lista.<br/><br/>" +
      "2. Presentes enviados por usuários com várias mensagens serão combinados e contados.<br/><br/>" +
      "3. Após o evento, os 10 melhores usuários receberão recompensas.",
    "get": "Obter",
    "monthly": "Benefícios Mensais",
    "dailyBenefits": "Benefícios Diários",
    "trFive": "Recompensa",
    "ruby": "Rubi",
    "gold": "Ouro",
    "register":
      "1. Recompensas mensais: Quando o valor de recarga do participante atingir o valor específico, o participante deve clicar manualmente no botão \"receber\" para receber o pacote de prêmios completo.<br/>" +
      "2. As recompensas são redefinidas no dia 1 de cada mês. Se a ação não for reivindicada, os participantes perderão seus prêmios se não os resgatarem. O aplicativo não será responsável por prêmios perdidos.<br/>" +
      "3. Para os usuários que receberam o ID especial, entre em contato com a equipe do App. A produção de presentes especiais levará 7 dias.<br/>" +
      "4. A atividade de recarga será baseada no horário da Arábia Saudita, do primeiro dia de cada mês até o primeiro dia do próximo mês.<br/>" +
      "5. Após obter as Estrelas de Recarga por 3 vezes consecutivas, você as terá permanentemente.<br/>" +
      "6. O aplicativo tem o direito final sobre essa atividade. Regras de atualização do ID de recarga mensal.<br/>" +
      "7. O horário mensal é o horário da Arábia Saudita, do primeiro dia de cada mês até o primeiro dia do próximo mês.<br/>" +
      "8. Para mais detalhes, entre em contato com o ID 1.",
    "goldRule":
      "1. Recompensas diárias: Quando os participantes atingirem um valor específico de recarga, devem clicar manualmente no botão \"Obter\" para receber os coins adicionais.<br/>" +
      "2. Recompensas mensais: Quando os participantes atingirem um valor específico de recarga, devem clicar manualmente no botão \"OBTER\" para receber o pacote completo de prêmios.<br/>" +
      "3. Se a ação não for reivindicada, os participantes perderão seus prêmios se não os resgatarem. O aplicativo não será responsável por prêmios perdidos.<br/>" +
      "4. Para os usuários que receberam o ID especial, entre em contato com a equipe do App. A produção de presentes especiais levará 7 dias.<br/>" +
      "5. A atividade de recarga será baseada no horário da Arábia Saudita, do primeiro dia de cada mês até o primeiro dia do próximo mês.<br/>" +
      "6. Após obter as Estrelas de Recarga por 3 vezes consecutivas, você as terá permanentemente.<br/>" +
      "7. O aplicativo tem o direito final sobre essa atividade.<br/><br/>" +
      "- Regras de atualização do ID de recarga mensal <br/>" +
      "1. O horário mensal é o horário da Arábia Saudita, do primeiro dia de cada mês até o primeiro dia do próximo mês.<br/>" +
      "2. O ID não pode ser transferido para outras contas.<br/>" +
      "3. Cada ID pode ser definido uma vez por mês através da recarga mensal.<br/>" +
      "4. Cada conta pode obter apenas um ID por mês através da recarga mensal.<br/>" +
      "5. Para mais detalhes, entre em contato com o ID 1.",
    "r": "Recarga",
    "help": "Ajuda"
},
    id:{
    "topLovers": "Top Lovers",
    "treeOfLovers": "Pohon Cinta",
    "rule": "Aturan",
    "timeR": "Hitung mundur: ",
    "days": "hari",
    "ranking": "Peringkat",
    "rewards": "Hadiah",
    "rulesDeil":
      "1. Selama Ramadan, hadiah yang dikirim oleh pengguna pada siaran akan tercatat dan dihitung dalam daftar ini.<br/><br/>" +
      "2. Hadiah yang dikirim oleh pengguna dengan beberapa pesan akan digabungkan dan dihitung.<br/><br/>" +
      "3. Setelah acara, 10 pengguna teratas akan menerima hadiah.",
    "get": "Dapatkan",
    "monthly": "Manfaat Bulanan",
    "dailyBenefits": "Manfaat Harian",
    "trFive": "Hadiah",
    "ruby": "Ruby",
    "gold": "Emas",
    "register":
      "1. Hadiah bulanan: Ketika pengisian ulang peserta mencapai jumlah tertentu, peserta harus mengklik manual tombol \"terima\" untuk menerima hadiah paket lengkap.<br/>" +
      "2. Hadiah direset pada tanggal 1 setiap bulan. Tindakan yang tidak diklaim, peserta akan kehilangan hadiahnya jika mereka tidak menebus hadiah mereka. Aplikasi tidak bertanggung jawab atas hadiah yang hilang.<br/>" +
      "3. Untuk pengguna yang menerima ID Khusus mereka, harap hubungi tim Aplikasi. Produksi Hadiah Khusus akan memerlukan waktu 7 hari untuk diproduksi.<br/>" +
      "4. Aktivitas pengisian ulang akan didasarkan pada waktu KSA dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya.<br/>" +
      "5. Setelah memperoleh Recharge Stars untuk 3 kali berturut-turut, Anda akan memilikinya secara permanen.<br/>" +
      "6. Aplikasi memiliki hak akhir atas aktivitas ini. Aturan pembaruan ID pengisian ulang bulanan.<br/>" +
      "7. Waktu bulanan adalah waktu Saudi dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya.<br/>" +
      "8. Untuk informasi lebih lanjut, hubungi ID 1.",
    "goldRule":
      "1. Hadiah harian: Ketika peserta mencapai jumlah pengisian ulang tertentu, peserta harus mengklik manual tombol \"Dapatkan\" untuk menerima koin tambahan.<br/>" +
      "2. Hadiah bulanan: Ketika peserta mencapai jumlah pengisian ulang tertentu, peserta harus mengklik manual tombol \"Dapatkan\" untuk menerima hadiah paket lengkap.<br/>" +
      "3. Tindakan yang tidak diklaim, peserta akan kehilangan hadiah mereka jika mereka tidak menebus hadiah mereka. Aplikasi tidak bertanggung jawab atas hadiah yang hilang.<br/>" +
      "4. Untuk pengguna yang menerima ID Khusus mereka, harap hubungi tim Aplikasi. Produksi Hadiah Khusus akan memerlukan waktu 7 hari untuk diproduksi.<br/>" +
      "5. Aktivitas pengisian ulang akan didasarkan pada waktu KSA dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya.<br/>" +
      "6. Setelah memperoleh Recharge Stars untuk 3 kali berturut-turut, Anda akan memilikinya secara permanen.<br/>" +
      "7. Aplikasi memiliki hak akhir atas aktivitas ini.<br/><br/>" +
      "- Aturan pembaruan ID pengisian ulang bulanan <br/>" +
      "1. Waktu bulanan adalah waktu Saudi dari tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya.<br/>" +
      "2. ID tidak dapat dipindahkan ke akun lain.<br/>" +
      "3. Setiap ID dapat diset satu kali sebulan melalui pengisian ulang bulanan.<br/>" +
      "4. Setiap akun hanya dapat memperoleh satu ID per bulan melalui pengisian ulang bulanan.<br/>" +
      "5. Untuk informasi lebih lanjut, hubungi ID 1.",
    "r": "Isi Ulang",
    "help": "Bantuan"
},
    uz:{
    "topLovers": "Top Lovers",
    "treeOfLovers": "Sevishganlar Daraxti",
    "rule": "Qoidalar",
    "timeR": "Qoldi: ",
    "days": "kun",
    "ranking": "Reyting",
    "rewards": "Mukofotlar",
    "rulesDeil":
      "1. Ramazon oyida foydalanuvchilar tomonidan yuborilgan sovg'alar efirda yozib olinadi va ushbu ro'yxatda hisobga olinadi.<br/><br/>" +
      "2. Bir nechta xabar yuborgan foydalanuvchilar tomonidan yuborilgan sovg'alar birlashtiriladi va hisoblanadi.<br/><br/>" +
      "3. Tadbirdan so'ng eng yaxshi 10 foydalanuvchi mukofotlarni oladi.",
    "get": "Olish",
    "monthly": "Oylik Foydalar",
    "dailyBenefits": "Kundalik Foydalar",
    "trFive": "Mukofot",
    "ruby": "Ruby",
    "gold": "Oltin",
    "register":
      "1. Oylik mukofotlar: Ishtirokchining to'lovlari ma'lum miqdorga yetganida, ishtirokchi \"qabul qilish\" tugmasini qo'lda bosishi kerak, shunda butun paket sovg'asini olish mumkin.<br/>" +
      "2. Mukofotlar har oyning 1-kunida yangilanadi. Agar sovg'alar talab qilinmasa, ishtirokchilar mukofotlarini yo'qotadilar, agar ular sovg'alarni olishni unutgan bo'lsa. Ilova yo'qotilgan sovg'alar uchun javobgar emas.<br/>" +
      "3. Maxsus ID olgan foydalanuvchilar uchun ilova jamoasi bilan bog'laning. Maxsus Sovg'alar ishlab chiqarilishi uchun 7 kun kerak.<br/>" +
      "4. To'lov faolligi har oyning 1-kunidan, keyingi oyning 1-kunigacha KSA vaqti bilan amalga oshiriladi.<br/>" +
      "5. 3 marta ketma-ket Recharge Starsni olishdan so'ng, uni doimiy ravishda olasiz.<br/>" +
      "6. Ilova ushbu faollikning yakuniy huquqiga ega. Oylik to'lov ID yangilash qoidalari<br/>" +
      "7. Oylik vaqt Saudiya vaqti bilan har oyning 1-kunidan, keyingi oyning 1-kunigacha.<br/>" +
      "8. Qo'shimcha ma'lumotlar uchun ID 1 bilan bog'laning.",
    "goldRule":
      "1. Kunlik mukofotlar: Ishtirokchilar to'lovlari ma'lum miqdorga yetganida, ishtirokchilar \"Olish\" tugmasini qo'lda bosishi kerak, shunda qo'shimcha tangalar olish mumkin.<br/>" +
      "2. Oylik mukofotlar: Ishtirokchilar to'lovlari ma'lum miqdorga yetganida, ishtirokchilar \"OLISH\" tugmasini qo'lda bosishi kerak, shunda butun paket sovg'asini olish mumkin.<br/>" +
      "3. Talab qilinmagan harakatlar, ishtirokchilar sovg'alarini olishni unutgan bo'lsa, mukofotlarini yo'qotadilar. Ilova yo'qotilgan sovg'alar uchun javobgar emas.<br/>" +
      "4. Maxsus ID olgan foydalanuvchilar uchun ilova jamoasi bilan bog'laning. Maxsus Sovg'alar ishlab chiqarilishi uchun 7 kun kerak.<br/>" +
      "5. To'lov faolligi har oyning 1-kunidan, keyingi oyning 1-kunigacha KSA vaqti bilan amalga oshiriladi.<br/>" +
      "6. 3 marta ketma-ket Recharge Starsni olishdan so'ng, uni doimiy ravishda olasiz.<br/>" +
      "7. Ilova ushbu faollikning yakuniy huquqiga ega.<br/><br/>" +
      "- Oylik to'lov ID yangilash qoidalari <br/>" +
      "1. Oylik vaqt Saudiya vaqti bilan har oyning 1-kunidan, keyingi oyning 1-kunigacha.<br/>" +
      "2. ID boshqa hisoblarga o'tkazib bo'lmaydi.<br/>" +
      "3. Har bir ID bir oyda faqat bir marta to'lov orqali o'rnatilishi mumkin.<br/>" +
      "4. Har bir hisob bir oyda faqat bitta ID olishi mumkin.<br/>" +
      "5. Qo'shimcha ma'lumotlar uchun ID 1 bilan bog'laning.",
    "r": "To'lov",
    "help": "Yordam"
},

    ru:{
    "topLovers": "Лучшие любители",
    "treeOfLovers": "Дерево Любви",
    "rule": "Правила",
    "timeR": "Обратный отсчет: ",
    "days": "дней",
    "ranking": "Рейтинг",
    "rewards": "Награды",
    "rulesDeil":
      "1. Во время Рамадана подарки, отправленные пользователями через трансляцию, будут записаны и учтены в этом списке.<br/><br/>" +
      "2. Подарки, отправленные пользователями с несколькими сообщениями, будут объединены и подсчитаны.<br/><br/>" +
      "3. После мероприятия топ-10 пользователей получат награды.",
    "get": "Получить",
    "monthly": "Ежемесячные выгоды",
    "dailyBenefits": "Ежедневные выгоды",
    "trFive": "Награда",
    "ruby": "Рубин",
    "gold": "Золото",
    "register":
      "1. Ежемесячные награды: Когда сумма пополнений участника достигает определенной величины, участник должен вручную нажать кнопку \"получить\", чтобы получить весь пакет подарков.<br/>" +
      "2. Награды сбрасываются 1 числа каждого месяца. Если подарки не были забраны, участники теряют свои призы, если не успеют их получить. Приложение не несет ответственности за утраченные подарки.<br/>" +
      "3. Для пользователей, получивших свой Специальный ID. Пожалуйста, свяжитесь с командой приложения. Производство Специальных Подарков займет 7 дней.<br/>" +
      "4. Активность пополнений будет основана на времени KSA с 1 числа каждого месяца по 1 число следующего месяца.<br/>" +
      "5. После того как вы получите Recharge Stars 3 раза подряд, вы получите его навсегда.<br/>" +
      "6. Приложение имеет окончательное право на эту активность. Правила обновления ID ежемесячного пополнения.<br/>" +
      "7. Месячное время — это время Саудовской Аравии с 1 числа каждого месяца по 1 число следующего месяца.<br/>" +
      "8. Для получения дополнительной информации свяжитесь с ID 1.",
    "goldRule":
      "1. Ежедневные награды: Когда пополнение участников достигает определенной суммы, участники должны вручную нажать кнопку \"Получить\", чтобы получить дополнительные монеты.<br/>" +
      "2. Ежемесячные награды: Когда пополнение участников достигает определенной суммы, участники должны вручную нажать кнопку \"ПОЛУЧИТЬ\", чтобы получить весь пакет подарков.<br/>" +
      "3. Если действия не были забраны, участники теряют свои призы, если не успеют их получить. Приложение не несет ответственности за утраченные подарки.<br/>" +
      "4. Для пользователей, получивших свой Специальный ID. Пожалуйста, свяжитесь с командой приложения. Производство Специальных Подарков займет 7 дней.<br/>" +
      "5. Активность пополнений будет основана на времени KSA с 1 числа каждого месяца по 1 число следующего месяца.<br/>" +
      "6. После того как вы получите Recharge Stars 3 раза подряд, вы получите его навсегда.<br/>" +
      "7. Приложение имеет окончательное право на эту активность.<br/><br/>" +
      "- Правила обновления ID ежемесячного пополнения <br/>" +
      "1. Месячное время — это время Саудовской Аравии с 1 числа каждого месяца по 1 число следующего месяца.<br/>" +
      "2. ID не может быть передан на другие аккаунты.<br/>" +
      "3. Каждый ID можно установить только один раз в месяц через ежемесячное пополнение.<br/>" +
      "4. Каждый аккаунт может получить только один ID в месяц через ежемесячное пополнение.<br/>" +
      "5. Для получения дополнительной информации свяжитесь с ID 1.",
    "r": "Пополнение",
    "help": "Помощь"
}



}



// WEBPACK FOOTER //
// src/pages/activity/goldRubyRecharge/lang.js